module.exports = __webpack_public_path__ + "static/media/Interactive.1b5d288b.svg";